import * as React from "react";
import type { SVGProps } from "react";
const SvgOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.944 2.4 21.577 8l.023 7.944-5.6 5.633-7.944.023L2.423 16 2.4 8.055 8 2.423z"
    />
  </svg>
);
export default SvgOctagon;
